const PRODUCCION = false;

let API_PAYPAL = "https://www.sandbox.paypal.com/cgi-bin/webscr";
if (PRODUCCION) {
  API_PAYPAL = "https://www.paypal.com/cgi-bin/webscr";
}

let URL_CLUDSF = "https://us-central1-pixancloud-test.cloudfunctions.net";
if (PRODUCCION) {
  URL_CLUDSF = "https://us-central1-pixan-cloud.cloudfunctions.net";
}

export { PRODUCCION, API_PAYPAL, URL_CLUDSF };



// WEBPACK FOOTER //
// ./src/constantes/environment.js